import { Link } from 'react-router-dom'

export default function ConsultationCard({ item, liveRating }) {
  // The astrologer record's own rating/reviews_count aren't kept in sync
  // upstream (verified null even for astrologers with real reviews) — prefer
  // the live GET /reviews aggregate passed down by the parent list, falling
  // back to the record's field only while it's pending/unavailable.
  const liveResolved = liveRating && !liveRating.isPending
  const rating = liveResolved ? liveRating.averageRating : item.rating
  const reviewCount = liveResolved ? liveRating.totalReviews : item.reviews
  const featured = liveResolved ? reviewCount > 0 && rating >= 4.5 : item.featured

  return (
    <article className="astro-pro-card">
      <div className="cq-row">
        <div className="cq-photo">
          <div
            className="absolute inset-0 flex items-center justify-center font-cinzel text-6xl font-bold"
            style={{ background: item.fallbackGradient, color: 'rgba(120,50,0,.5)' }}
          >
            {item.fallbackLetter}
          </div>
          {item.image && (
            <img
              src={item.image}
              alt={item.title}
              loading="lazy"
              onError={(e) => { e.currentTarget.style.opacity = '0' }}
            />
          )}
          <div className="absolute inset-x-3 top-3 flex items-center justify-between z-10">
            <span className="meta-pill">{item.typeLabel}</span>
            <span className="meta-pill">{item.exp} yr{item.exp === 1 ? '' : 's'} exp</span>
          </div>
          {featured && <div className="feat-ribbon">Top Rated</div>}
        </div>
        <div className="cq-body">
          <div className="flex items-center justify-between gap-3 flex-wrap">
            <span className="meta-pill">{item.categoryLabel}</span>
            <span className="flex items-center gap-1.5 text-sm">
              <span className="text-[#C8922A] font-semibold">★ {reviewCount > 0 ? rating.toFixed(1) : 'New'}</span>
              <span className="text-[#8B7355] text-xs">({reviewCount} review{reviewCount === 1 ? '' : 's'})</span>
            </span>
          </div>
          <h3 className="mt-2 text-lg sm:text-xl font-bold text-[#1C140A] leading-snug">{item.title}</h3>
          <p className="mt-1.5 text-sm leading-relaxed text-[#5C3A18] line-clamp-2">{item.desc}</p>
          <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1.5 text-[12px] text-[#8B7355]">
            {item.languages.length > 0 && (
              <>
                <span>
                  Speaks <strong className="text-[#1C140A] font-semibold">{item.languages.join(', ')}</strong>
                </span>
                <span className="cq-meta-dot" />
              </>
            )}
            <span>{item.duration} min</span>
            <span className="cq-meta-dot" />
            <span>{item.typeLabel}</span>
          </div>
          <div className="astro-divider mt-4" />
          <div className="mt-4 flex flex-wrap items-center justify-between gap-3">
            <div>
              <p className="text-lg font-bold text-[#C8922A] leading-none">
                {item.price > 0 ? `₹${item.price.toLocaleString('en-IN')}` : 'Free'}
              </p>
              <p className="mt-1 text-[9px] uppercase tracking-[0.3em] text-[#9A7A58]">per session</p>
            </div>
            <div className="flex flex-wrap gap-2">
              <Link
                to={`/astrologers/${item.id}/book`}
                className="inline-flex items-center justify-center rounded-full border border-[#D4AF37]/25 bg-[#1C140A] px-4 py-2.5 text-[11px] font-semibold uppercase tracking-[0.25em] text-white transition hover:bg-[#3A1E0C]"
              >
                Book Now
              </Link>
              <Link
                to={`/astrologers/${item.id}`}
                className="inline-flex items-center justify-center rounded-full border border-[#D4AF37]/25 bg-white px-4 py-2.5 text-[11px] font-semibold uppercase tracking-[0.25em] text-[#1C140A] transition hover:border-secondary"
              >
                View Details
              </Link>
            </div>
          </div>
        </div>
      </div>
    </article>
  )
}
